import { Component, VERSION, ViewChild, OnInit, ContentChild, ElementRef } from '@angular/core';
import { ExcelService } from 'src/app/service/excel.service';
import { Cell, Workbook } from 'exceljs';
import * as fs from 'file-saver';


// PDF export
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';
import { TestReportComponent } from '../reports/test-report/test-report.component';
// import pdfMake from '';
// import { pdfMake } from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare let pdfMake: any;
// declare let pdfMake: any ;

declare var $: any;
@Component({
  selector: 'app-test-excel',
  templateUrl: './test-excel.component.html',
  styleUrls: ['./test-excel.component.scss']
})
export class TestExcelComponent implements OnInit {

  name = 'Angular ' + VERSION.major;
  data: any;
  @ViewChild("myImage") myImage: any;
  // pdf
  @ViewChild('pdfPage') pdfPage: any;

  // Component
  @ViewChild("testReport", { static: false, read: ElementRef }) testReport: any;
  // @ViewChild(TestReportComponent, {read: ElementRef}) testReport: TestReportComponent;

  constructor(private excelService: ExcelService) {
    this.data = [
      [2019, 1, '50', '20', '25', '20'],
      [2019, 2, '80', '20', '25', '20'],
      [2019, 3, '120', '20', '25', '20'],
      [2019, 4, '75', '20', '25', '20'],
      [2019, 5, '60', '20', '25', '20'],
      [2019, 6, '80', '20', '25', '20'],
      [2019, 7, '95', '20', '25', '20'],
      [2019, 8, '55', '20', '25', '20'],
      [2019, 9, '45', '20', '25', '20'],
      [2019, 10, '80', '20', '25', '20'],
      [2019, 11, '90', '20', '25', '20'],
      [2019, 12, '110', '20', '25', '20'],
    ];

  }
  ngOnInit() {
    // this.loadScript();
    this.updateTable();
    this.updateSecondTable();
  }
  // generateExcel() {

  //   // console.log('called');
  //   this.excelService.generateExcel();
  // }

  async generateExcel() {
    // Excel Title, Header, Data
    const title = 'Yearly Social Sharing Education For Betterment';
    const header = [
      'Year',
      'Month',
      'Facebook',
      'Reddit',
      'LinkedIn',
      'Instagram'
    ];
    const data = this.data;

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sharing Data');

    // Add Row and formatting
    const titleRow = worksheet.addRow([title]);
    titleRow.font = {
      name: 'Corbel',
      family: 4,
      size: 16,
      underline: 'double',
      bold: true
    };

    worksheet.addRow([]);
    const subTitleRow = worksheet.addRow(['Date : 06-09-2020']);

    worksheet.mergeCells('A1:D2');

    // Blank Row
    worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    // const imageId1 = workbook.addImage({
    //   filename:
    //     'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png',
    //   extension: 'jpeg'
    // });
    //worksheet.addImage(imageId1, 'G6:H8');
    // Add Data and Conditional Formatting
    data.forEach((d: any) => {
      let imageBase64 = d[6];
      let imageId1 = workbook.addImage({
        // buffer: fs.readFileSync(
        //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png'
        // ),
        base64: imageBase64,
        extension: 'png'
      });
      // worksheet.addImage(imageId1, 'G20:H22');
      // d[6] = imageId1;
      // worksheet.addImage(imageId1, 'G20:H22');
      const row = worksheet.addRow(d.slice(0, 5));
      row.height = 30;
      worksheet.addImage(imageId1, 'G' + (6 + imageId1) + ':G' + (6 + imageId1));
      let qty: any;
      qty = row.getCell(5);
      // as Cell | undefined
      let color = 'FF99FF99';
      if (+qty.value < 500) {
        color = 'FF9999';
      }

      qty.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: color }
      };
    });

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;

    worksheet.getColumn(7).width = 30;
    worksheet.addRow([]);

    //     let workbook2 = Excel.stream.xlsx.WorkbookWriter()
    // workbook2.media.push({
    //     filename: './Picture1.png',
    //     extension: 'png',
    //   })
    // worksheet.addImage(0, 'B1:E6')

    // Ali
    // const logoBase64 =
    //   'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAFKCAMAAADcyF29AAABxVBMVEVHcEwJCAggFxEBAQE2KyQAAAA0LScAAAAAAAA1LysXEQ0EBAQFBAMDAwMLCQgGBQUFBAOEQhUHBwZjQSuScFoVFRZvNAx5NghcOyaudU8yMDBrNhOiViMZFhXEdD3Ef0+4ZzFISUdSJwliMA6BPA6lVR8CAgEDAgQPDhANDgsKCQoVFhPObi4SERS2VxcE.......';
    //
    // const readFileInNode = (filename) => {
    //   console.log('readFileInNode - fs', fs)
    //   console.log('readFileInNode - fsMod', fsMod)
    //   return new Promise((resolve, reject) => fs.readFile(filename, 'utf8', (err, data) => err ? reject(err) : resolve(data)))
    // }
    //Test base 64 image 
    // let image = document.createElement('img');
    // image.width = 10;
    // image.height = 10;
    // image.src = "https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png";
    //end
    // console.log(this.myImage.nativeElement);
    // add image to workbook by buffer
    // const imageId1 = workbook.addImage({
    //   // buffer: fs.readFileSync(
    //   //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png'
    //   // ),
    //   base64: this.getDataUrl(this.myImage.nativeElement),
    //   extension: 'png'
    // });

    // const imageId1 = workbook.addImage({
    //   // filename:
    //   //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png',
    //   base64: logoBase64,
    //   extension: 'png'
    // });
    // worksheet.addImage(imageId1, 'G20:H22');
    // Footer Row
    const footerRow = worksheet.addRow([
      'This is system generated excel sheet.'
    ]);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      fs.saveAs(blob, 'SocialShare.xlsx');
    });
  }

  getDataUrl(img: any) {
    // Create canvas
    const canvas = document.createElement('canvas');
    let ctx: any;
    ctx = canvas.getContext('2d');
    // Set width and height
    canvas.width = img.width;
    canvas.height = img.height;
    // Draw the image
    ctx.drawImage(img, 0, 0);
    return canvas.toDataURL('image/jpeg');
  }


  getBase64(event: any, index: number) {
    let img = event.target;
    let dataURL: any;
    var canvas = document.createElement('canvas');
    let ctx: any;
    ctx = canvas.getContext('2d');
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
    dataURL = canvas.toDataURL('image/jpeg');
    this.data[index][6] = dataURL;
    console.log("test func: ");
    console.log(dataURL);
    console.log("data: ");
    console.log(this.data);
  }

  // test pdf
  downloadPDF() {

    // var node = document.getElementById('parentdiv');
    var node = this.pdfPage.nativeElement;

    var img: any;
    var filename: any;
    var newImage: any;


    domtoimage.toPng(node, { bgcolor: '#fff', quality: 0.95 })

      .then(function (dataUrl: any) {

        img = new Image();
        img.src = dataUrl;
        newImage = img.src;

        img.onload = function () {

          var pdfWidth = img.width;
          var pdfHeight = img.height;

          // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image

          var doc;

          if (pdfWidth > pdfHeight) {
            doc = new jsPDF('l', 'px', [pdfWidth, pdfHeight]);
          }
          else {
            doc = new jsPDF('p', 'px', [pdfWidth, pdfHeight]);
          }


          var width = doc.internal.pageSize.getWidth();
          var height = doc.internal.pageSize.getHeight();


          doc.addImage(newImage, 'PNG', 10, 10, width, height);
          filename = 'mypdf_' + '.pdf';
          doc.save(filename);

        };


      })
      .catch(function (error: any) {
        console.log(error);
        // Error Handling

      });
  }
  testJsPdf() {
    let pdf = new jsPDF('p', 'pt', 'a4');
    pdf.html(this.pdfPage.nativeElement, {
      callback: (pdf) => {
        pdf.save("test.pdf");
      }
    });
  }

  downloadPDFWithjsPDF() {
    let doc = new jsPDF('p', 'pt', 'a4');

    doc.html(this.pdfPage.nativeElement, {
      callback: function (doc) {
        doc.save('MLB World Series Winners.pdf');
      },
      margin: [60, 60, 60, 60],
      x: 32,
      y: 32,
    });
  }

  updateTable() {
    pdfMake.fonts = {
      Arial: {
        normal: 'arial.ttf',
        bold: 'arialbd.ttf',
        italics: 'ariali.ttf',
        bolditalics: 'arialbi.ttf'
      }
    };
    $("#datatable").DataTable().destroy();
    $('#datatable thead tr')
      .clone(true)
      .addClass('filters')
      .appendTo('#datatable thead');
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',

        // Filter params start
        orderCellsTop: true,
        fixedHeader: true,
        initComplete: function () {
          var api = this.api();

          // For each column
          api
            .columns()
            .eq(0)
            .each(function (colIdx: any) {
              // Set the header cell to contain the input element
              var cell = $('.filters th').eq(
                $(api.column(colIdx).header()).index()
              );
              var title = $(cell).text();
              $(cell).html('<input type="text" placeholder="' + title + '" />');

              // On every keypress in this input
              $(
                'input',
                $('.filters th').eq($(api.column(colIdx).header()).index())
              )
                .off('keyup change')
                .on('keyup change', function (e: any) {
                  e.stopPropagation();

                  // Get the search value
                  $(e.target).attr('title', $(e.target).val());
                  var regexr = '({search})'; //$(this).parents('th').find('select').val();

                  var cursorPosition = e.target.selectionStart;
                  // Search the column for that value
                  api
                    .column(colIdx)
                    .search(
                      e.target.value != ''
                        ? regexr.replace('{search}', '(((' + e.target.value + ')))')
                        : '',
                      e.target.value != '',
                      e.target.value == ''
                    )
                    .draw();

                  $(e.target)
                    .focus()[0]
                    .setSelectionRange(cursorPosition, cursorPosition);
                });
            });
        },

        // Filter params end


        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        // "columnDefs": [
        //   {
        //     targets: 7, // Status
        //     data: null, // Use the full data source object for the renderer's source
        //     render: function (data: any, type: any, row: any, meta: any) {

        //       if (!data || typeof data === 'undefined' || data === null)
        //         return 'Unlocked';
        //       else if (data === 'locked')
        //         return 'Locked';
        //       else
        //         return 'Secured';
        //     }
        //   }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'pdfHtml5',
          text: 'PDF',
          customize: (doc: any) => {
            doc.defaultStyle =
            {
              font: 'Arial',
            };
            //find paths of all images, already in base64 format
            // var arr2 = $('.img-fluid').map(function () {

            //   console.log(obj)
            //   console.log($(obj).src);
            //   return $(obj).src;
            // }).get();

            for (var i = 1, c = 7; i < doc.content[1].table.body.length; i++) {
              // doc.content[1].table.body[c][7] = "test" + i;
              // console.log(doc.content[1].table.body[i][c].text);
              doc.content[1].table.body[i][c] = {
                // image: "data:image/png;base64,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",
                // width: 100
                image: this.data[i - 1][6]
              };
            }
          },
          titleAttr: 'PDF',
          className: 'btn-outline-danger btn-sm ',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7]
          }
        },
        {
          extend: 'excel',
          text: 'excel',
          titleAttr: 'excel',
          customize: function (xlsx: any) {
            var sheet = xlsx.xl.worksheets['sheet1.xml'];
            var numrows = 3;
            var clR = $('row', sheet);

            //update Row
            clR.each(function (index: any, element: any) {
              console.log(JSON.stringify(element));
              var attr = $(element).attr('r');
              var ind = parseInt(attr);
              ind = ind + numrows;
              $(element).attr("r", ind);
            });

            // Create row before data
            // $('row c ', sheet).each(function (index: any, element: any) {
            //   var attr = $(element).attr('r');
            //   var pre = attr.substring(0, 1);
            //   var ind = parseInt(attr.substring(1, attr.length));
            //   ind = ind + numrows;
            //   $(element).attr("r", pre + ind);
            // });

            // function Addrow(index: any, data: any) {
            //   let msg = '<row r="' + index + '">';
            //   for (let i = 0; i < data.length; i++) {
            //     var key = data[i].key;
            //     var value = data[i].value;
            //     msg += '<c t="inlineStr" r="' + key + index + '">';
            //     msg += '<is>';
            //     msg += '<t>' + value + '</t>';
            //     msg += '</is>';
            //     msg += '</c>';
            //   }
            //   msg += '</row>';
            //   return msg;
            // }


            //insert
            // var r1 = Addrow(1, [{ key: 'A', value: '' }, { key: 'B', value: '' }]);
            // var r2 = Addrow(2, [{ key: 'A', value: '' }, { key: 'B', value: '' }]);
            // var r3 = Addrow(3, [{ key: 'A', value: '' }, { key: 'B', value: '' }]);

            // sheet.childNodes[0].childNodes[1].innerHTML = r1 + r2 + r3 + sheet.childNodes[0].childNodes[1].innerHTML;
          },
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7]
          },
        }
        ],
      });
    }, 1);

  }

  updateSecondTable() {
    $("#example").DataTable().destroy();
    setTimeout(() => {
      $(document).ready(function () {
        var table = $('#example').DataTable({
          dom: 'Bfrtip',
          rowReorder: true,
          select: true,
          columnDefs: [
            { orderable: true, className: 'reorder', targets: [0, 1] },
            // { orderable: true, targets: '_all' }
          ]
        });

        // Start sort investigation
        var reorder = false;
        var searched = false;
        var origIndexes = [];
        var origSeq: any = [];
        var origNim = [];
        table.on('order.dt', function (event: any) {
          console.log('order', reorder, searched);
          //don't adjust "#" column if already changed by rowReorder or search events
          if (!reorder && !searched) {
            console.log('order.dt - resetting order');
            let i = 1;
            //assign "#" values in row order
            table.rows({ search: 'applied', order: 'applied' }).every(function (rowIdx: any, tableLoop: any, rowLoop: any) {
              var data = $(event.target).data();
              data['#'] = i;
              i++;
              $(event.target).data(data);
            });
          }
          //reset booleans
          reorder = false;
          searched = false;
        });

        table.on('search.dt', function (event: any) {
          console.log('search', reorder);
          //skip if reorder changed the "#" column order
          if (!reorder) {
            console.log('search.dt - resetting order');
            let i = 1;
            //assign "#" values in row order
            table.rows({ search: 'applied', order: 'applied' }).every(function (rowIdx: any, tableLoop: any, rowLoop: any) {
              var data = $(event.target).data();
              data['#'] = i;
              i++;
              $(event.target).data(data);
            });
          }
          //don't change "#" order in the order event
          searched = true;
        });


        table.on('row-reorder', function (e: any, details: any, edit: any) {
          console.log('row-reorder');
          //get original row indexes and original sequence (rowReorder indexes)
          origIndexes = table.rows().indexes().toArray();
          origSeq = table.rows().data().pluck('sequence').toArray();
        });



        table.on('row-reordered', function (e: any, details: any, edit: any) {
          console.log('row-reorderd');
          //get current row indexes and sequence (rowReorder indexes)
          var indexes = table.rows().indexes().toArray();
          //console.log('org indexes', origIndexes);
          //console.log('new indexes', indexes);
          var seq = table.rows().data().pluck('sequence').toArray();
          //console.log('org seq', origSeq);
          //console.log('new seq', seq);
          let i = 1;

          for (var r = 0; r < indexes.length; r++) {
            //get row data
            var data = table.row(indexes[r]).data();
            //console.log('looking for',seq[r]);
            //get new sequence 
            //origSeq   [1, 3, 4, 2]
            //seq       [3, 4, 1, 2]
            //indexes   [0, 2, 3, 1]
            //use the new sequence number to find index in origSeq
            //the (index + 1) is the original row "#" to assign to the current row
            let newSeq = origSeq.indexOf(seq[r]);
            //console.log('found new seq',newSeq);

            //assign the new "#" to the current row
            data['#'] = newSeq + 1;
            table.row(indexes[r]).data(data);

          }
          //re-sort the table by the "#" column
          table.order([1, 'asc']);

          //don't adjust the "#" column in the search and order events
          reorder = true;
        });
        // End sort investigation
      });


    }, 1);

  }

  // public loadScript() {
  //   let body = <HTMLDivElement>document.body;
  //   let script1 = document.createElement('script');
  //   script1.innerHTML = '';
  //   script1.src = 'https://code.jquery.com/jquery-3.5.1.js';
  //   script1.async = true;
  //   script1.defer = true;
  //   body.appendChild(script1);

  //   let script2 = document.createElement('script');
  //   script2.innerHTML = '';
  //   script2.src = 'https://cdn.datatables.net/1.11.3/js/jquery.dataTables.min.js';
  //   script2.async = true;
  //   script2.defer = true;
  //   body.appendChild(script2);

  //   let scrip3 = document.createElement('script');
  //   scrip3.innerHTML = '';
  //   scrip3.src = 'https://cdn.datatables.net/rowreorder/1.2.8/js/dataTables.rowReorder.min.js';
  //   scrip3.async = true;
  //   scrip3.defer = true;
  //   body.appendChild(scrip3);
  // }

  exportReportToPdf() {
    // console.log("export process");
    if (this.testReport) {
      // console.log(this.testReport.nativeElement.innerHTML);
      // pdfMake.fonts = {
      //   Arial: {
      //     normal: 'arial.ttf',
      //     bold: 'arialbd.ttf',
      //     italics: 'ariali.ttf',
      //     bolditalics: 'arialbi.ttf'
      //   }
      // };
      // var blob = new Blob(["kk"])
      // var docDefinition = {
      //   content: [this.testReport.nativeElement.innerHTML],
      //   pageSize: 'A4',

      //   // by default we use portrait, you can change it to landscape if you wish
      //   pageOrientation: 'landscape',
      
      //   // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      //   pageMargins: [ 40, 60, 40, 60 ],
      //   defaultStyle: {
      //     font: "Arial",
      // },
      // // styles:{
        
      // // }
      // }
      // pdfMake.createPdf(docDefinition).download();
      // console.log(pdfMake.vfs);
      // const font = pdfMake.vfs;
      // console.log(font['arial.ttf']);
      // let doc = new jsPDF('p', 'pt', 'a4');
      // doc.addFileToVFS("arial.ttf", font['arial.ttf']);
      // doc.addFileToVFS("arialbd.ttf", font['arialbd.ttf']);
      // doc.addFileToVFS("ariali.ttf", font['ariali.ttf']);
      // doc.addFileToVFS("arialbi.ttf", font['arialbi.ttf']);
      // doc.addFont("arial.ttf", "arial", "normal");
      // doc.addFont("arialbd.ttf", "arial", "bold");
      // doc.addFont("ariali.ttf", "arial", "italics");
      // doc.addFont("arialbi.ttf", "arial", "bolditalics");
      // doc.setFont("arial");
      // // // doc.addFont();
      // doc.html(this.testReport.nativeElement.innerHTML, {
      //   callback: function (doc) {
      //     doc.save('MLB World Series Winners.pdf');
      //   },
      //   // margin: [60, 60, 60, 60],
      //   x: 0,
      //   y: 0,
      // });

      html2canvas(this.testReport.nativeElement).then((canvas: any)=>{
        let img=canvas.toDataURL("image/png");
        let doc = new jsPDF();
        let width = doc.internal.pageSize.getWidth();
        let height = doc.internal.pageSize.getHeight();
        doc.addImage(img,'JPEG',0, 0, width, height);
        doc.save('test.pdf');
      });
      
    } else {
      console.log("undefined");
    }

  }
}
